export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";